import { useEffect } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { safeArray } from '../../../utils/safe';
import type * as yup from 'yup';
import { useSearchParams } from 'react-router-dom';

export interface FieldConfig { name: string; label: string; type?: 'text' | 'number' | 'select'; options?: string[]; placeholder?: string }
interface Props<T extends FieldValues> { defaultValues: T; schema: yup.ObjectSchema<T>; fields: FieldConfig[]; onSubmit: (values: T) => void }

export function FiltersForm<T extends FieldValues>({ defaultValues, schema, fields, onSubmit }: Props<T>) {
  const [search, setSearch] = useSearchParams();
  const form = useForm<T>({ defaultValues: defaultValues as any, resolver: yupResolver(schema) as any });
  useEffect(() => { const values: Record<string, any> = { ...defaultValues }; search.forEach((value, key) => { values[key] = value.includes(',') ? value.split(',') : value; }); form.reset(values as T); }, [defaultValues, form, search]);
  const submit = (values: T) => { const params = new URLSearchParams(); Object.entries(values).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') params.set(k, Array.isArray(v) ? v.join(',') : String(v)); }); setSearch(params, { replace: true }); onSubmit(values); };

  return (
    <form onSubmit={form.handleSubmit(submit as any)} className="mb-4 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {fields.map((field) => (
        <label key={field.name} className="flex flex-col gap-1 text-sm">
          <span className="font-medium">{field.label}</span>
          {field.type === 'select' ? <select className="rounded border p-2" {...form.register(field.name as any)}><option value="">Selecciona...</option>{safeArray(field.options).map((opt: string) => <option key={opt} value={opt}>{opt}</option>)}</select> : <input type={field.type ?? 'text'} placeholder={field.placeholder} className="rounded border p-2" {...form.register(field.name as any)} />}
          {form.formState.errors[field.name]?.message && <span className="text-xs text-red-600">{String(form.formState.errors[field.name]?.message)}</span>}
        </label>
      ))}
      <div className="flex items-end"><button type="submit" className="rounded bg-emerald-600 px-4 py-2 text-white">Aplicar filtros</button></div>
    </form>
  );
}
